import { forwardRef } from "react";
import NumberFormat from "react-number-format";
import type { NumberFormatProps } from "react-number-format";

type CustomNumberFormatIds = "fee" | "buyerFee" | "rooms" | "listingMatchToContacts";

type CustomNumericFormatProps = {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: CustomNumberFormatIds;
};

const customFeeProps: NumberFormatProps = {
  min: 0,
  max: 100,
  suffix: "%",
  decimalScale: 2,
  // Must be between 0 and 100 or empty
  isAllowed: ({ floatValue }) => !floatValue || (floatValue >= 0 && floatValue <= 100)
};

const customListingMatchToContactsProps: NumberFormatProps = {
  min: 0,
  max: 95,
  suffix: "%",
  decimalScale: 2,
  // Must be between 0 and 95 or empty
  isAllowed: ({ floatValue }) => !floatValue || (floatValue >= 0 && floatValue <= 95)
};

const customRoomsProps: NumberFormatProps = {
  min: 0,
  max: 20,
  decimalScale: 1,
  isAllowed: ({ floatValue }) =>
    !floatValue ||
    (floatValue >= 0 && floatValue <= 20 && (floatValue % 1 === 0 || floatValue % 1 === 0.5))
};

export const CustomNumericFormat = forwardRef<NumberFormatProps, CustomNumericFormatProps>(
  (props, ref) => {
    const { name, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={({ floatValue }) => {
          onChange({
            target: {
              name: name,
              value: floatValue
            }
          });
        }}
        decimalScale={0}
        thousandSeparator
        {...(["fee", "buyerFee"].includes(name) && customFeeProps)}
        {...(name === "rooms" && customRoomsProps)}
        {...(name === "listingMatchToContacts" && customListingMatchToContactsProps)}
      />
    );
  }
);
